/**
 * Legacy template shim — Teasers renders via Teaser instances.
 */
module.exports = function (app, mod) {
  var Teaser = require('./teaser');
  var html = '';
  for (var i = 0; i < mod.games.length; i++) {
    html += new Teaser(app, mod, mod.games[i]).renderHTML();
  }
  html += new Teaser(app, mod, null, {
    is_add_game: true
  }).renderHTML();
  return html;
};